module.exports = __webpack_public_path__ + "static/Especial_ilus_01-41814bb1e15a533bf14e8ecad5de47b8.png";